/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shortcut_Keys_Name_Export_FileInputs */



/**
* | output |
* | --- |
* | "Export File" |
*
* @param {Shortcut_Keys_Name_Export_FileInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const shortcut_keys_name_export_file = /** @type {((inputs?: Shortcut_Keys_Name_Export_FileInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shortcut_Keys_Name_Export_FileInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Exporter un fichier")
	if (locale === "de") return /** @type {LocalizedString} */ ("Exportdatei")
	if (locale === "it") return /** @type {LocalizedString} */ ("Esporta file")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Экспорт файла")
	if (locale === "es") return /** @type {LocalizedString} */ ("Exportar archivo")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("导出文件")
	if (locale === "ja") return /** @type {LocalizedString} */ ("ファイルのエクスポート")
	if (locale === "hi") return /** @type {LocalizedString} */ ("निर्यात फ़ाइल")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Arquivo de exportação")
	return /** @type {LocalizedString} */ ("Export File")
});